import React from "react";
import { useRevealGroup } from "../../hooks/useReveal";

const PANELS = [
  {
    badge: "Coming Soon",
    title: ["Design", "by Numbardar"],
    body:
      "Bespoke luxury interiors — curated by India's finest designers, furnished with imported luxury and celebrated local craftsmanship. From minimal contemporary to maximalist heritage, every space is an expression of its owner's legacy.",
    services: [
      "Bespoke Interior Design — Residential & Commercial",
      "Collaboration with Internationally Recognised Designers",
      "Curated Furniture: European Luxury + Indian Master Craftsmen",
      "Turn-Key Delivery — from concept to move-in",
      "Art Curation & Styling Services",
    ],
    image:
      "https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1400&q=80",
  },
  {
    badge: "Coming Soon",
    title: ["Built to", "Last Centuries"],
    body:
      "From neo-classical colonnades to modern clean lines, from Victorian grandeur to Mughal-inspired courtyards — we build with the rigour of the finest construction houses and the vision of the finest architects. One roof. Every style. Every era.",
    services: [
      "Custom Bungalow & Villa Construction",
      "Neo-Classical · Modern Classic · Victorian · Mughal-Heritage",
      "Premium Material Sourcing — Domestic & Imported",
      "Structural Engineering & Project Management",
      "Heritage Property Restoration & Renovation",
      "Commercial Build-Outs & Fit-Outs",
    ],
    image:
      "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1400&q=80",
  },
];

const ComingSoon = () => {
  const ref = useRevealGroup(".reveal");
  return (
    <section ref={ref} className="bg-ivory-grain py-24 lg:py-32" data-testid="coming-soon-section">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="reveal max-w-[720px] mb-16">
          <div className="flex items-center gap-3 mb-6">
            <span className="block w-10 h-px bg-num-gold" />
            <span className="font-ui text-[9px] uppercase text-num-gold track-eyebrow">
              Craft & Build
            </span>
          </div>
          <h2 className="font-display font-medium text-num-forest leading-[1.05]" style={{ fontSize: "clamp(34px, 4vw, 50px)" }}>
            Two new disciplines,{" "}
            <span className="font-italic italic font-normal text-num-gold">in the making.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {PANELS.map((p, i) => (
            <article
              key={i}
              className={`reveal delay-${i + 1} bg-num-cream border border-num-gold/20 group relative overflow-hidden`}
              data-testid={`coming-soon-panel-${i}`}
            >
              <div className="aspect-[16/9] img-zoom relative">
                <img src={p.image} alt={p.title.join(" ")} loading="lazy" className="w-full h-full object-cover" />
                <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(28,6,6,0.4), transparent 60%)" }} />
                <span className="absolute top-5 left-5 font-ui text-[9px] uppercase track-eyebrow bg-num-deep text-num-gold px-3 py-1.5 border border-num-gold/40">
                  {p.badge}
                </span>
              </div>
              <div className="p-9 lg:p-12">
                <h3 className="font-display font-medium text-num-forest leading-[1.05]" style={{ fontSize: "clamp(28px, 2.5vw, 38px)" }}>
                  {p.title[0]}<br />
                  <span className="font-italic italic font-normal text-num-gold">{p.title[1]}</span>
                </h3>
                <p className="font-ui font-light text-[13px] mt-5 leading-[1.85]" style={{ color: "#5e5443" }}>
                  {p.body}
                </p>
                <ul className="mt-7 space-y-2.5">
                  {p.services.map((s) => (
                    <li key={s} className="flex items-start gap-3 font-ui text-[11px] text-num-forest">
                      <span className="mt-[7px] block w-1 h-1 bg-num-gold flex-shrink-0" />
                      <span>{s}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-9">
                  <a
                    href="#contact"
                    className="btn-outline-forest inline-block px-7 py-3 font-ui text-[10px] uppercase track-label"
                    data-testid={`coming-soon-cta-${i}`}
                  >
                    Register Interest
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ComingSoon;
